import { FaqField } from "./FaqField";
import { Field } from "./Field";
import { FieldType } from "./FieldType";
import { GalleryField } from "./GalleryField";
import { MarkdownField } from "./MarkdownField";
import { OpinionField } from "./OpinionField";
import { RawFaqField } from "./RawFaqField";
import { RawField } from "./RawField";
import { RawGalleryField } from "./RawGalleryField";
import { RawMarkdownField } from "./RawMarkdownField";
import { RawOpinionField } from "./RawOpinionField";
import { RawTableField } from "./RawTableField";
import { RawTextField } from "./RawTextField";
import { RawTextWithPictureField } from "./RawTextWithPictureField";
import { TableField } from "./TableField";
import { TextField } from "./TextField";
import { TextWithPictureField } from "./TextWithPictureField";


export class DescriptionFieldConverter
{
    public static ToClass(raw: RawField): Field
    {
        switch (raw.Type as FieldType)
        {
            case FieldType.Markdown: return new MarkdownField(raw as RawMarkdownField);
            case FieldType.Faq: return new FaqField(raw as RawFaqField);
            case FieldType.Gallery: return new GalleryField(raw as RawGalleryField);
            case FieldType.Table: return new TableField(raw as RawTableField);
            case FieldType.Text: return new TextField(raw as RawTextField);
            case FieldType.TextWithPicture: return new TextWithPictureField(raw as RawTextWithPictureField);
            case FieldType.Opinion: return new OpinionField(raw as RawOpinionField);
            default: throw new Error(`[DescriptionFieldConverter] Unknown "${raw.Type}" description field type`);
        }
    }
}
